module.exports = __webpack_public_path__ + "img/mark.93eec465.svg";